import createReducer from '../utils/createReducer';
import {
  CURRENCY_SETTINGS_REQUEST,
  CURRENCY_SETTINGS_FAILURE,
  CURRENCY_SETTINGS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: {},
  token: null,
};

export default createReducer(initialState, {
  [CURRENCY_SETTINGS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [CURRENCY_SETTINGS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: payload.data,
      token: payload.token,
    })
  ),
  [CURRENCY_SETTINGS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/currencySetting.js